import { network } from "../network/network.js";
const endpoint = "/cart";
export async function fetchCart() {
    return await network(endpoint);
}
export async function updateCart(cart) {
    const updateInitEvent = new CustomEvent("cart:updating", {
        detail: cart,
    });
    document.dispatchEvent(updateInitEvent);
    const updatedCart = await network(endpoint, {
        method: "PATCH",
        json: cart,
    });
    const updateCompleteEvent = new CustomEvent("cart:updated", {
        detail: updatedCart,
    });
    document.dispatchEvent(updateCompleteEvent);
    return updatedCart;
}
export async function addCartItems(items, cart) {
    const _items = cart?.items.map(convertCartItemToInputItem) || [];
    _items.push(...items);
    return await updateCart({ items: _items.map(convertQuantity) });
}
export async function addCartItem(item, cart) {
    const reference = item?.reference || new Date().toString();
    const _items = cart?.items.map(convertCartItemToInputItem) || [];
    item.reference = reference;
    _items.push(item);
    const updatedCart = await updateCart({
        items: _items.map(convertQuantity),
    });
    return {
        cart: updatedCart,
        item: updatedCart.items.find((i) => i.reference === reference),
    };
}
export async function removeCartItems(cart, ids) {
    const itemsToKeep = cart.items
        .filter((i) => !ids.includes(i._id))
        .map(convertCartItemToInputItem);
    return await updateCart({ items: itemsToKeep.map(convertQuantity) });
}
export async function updateCartItem(cart, id, item) {
    const itemIndex = cart.items.findIndex((i) => i._id === id);
    if (itemIndex !== -1) {
        const items = cart.items.map(convertCartItemToInputItem);
        const currentItem = items[itemIndex];
        items[itemIndex] = { ...currentItem, ...item };
        return await updateCart({ items: items.map(convertQuantity) });
    }
    return cart;
}
export async function emptyCart() {
    return await updateCart({ items: [] });
}
export async function addDiscountCode(cart, code) {
    return await updateCart({ discountCodes: [...cart.discountCodes, code] });
}
export async function removeDiscountCode(cart, code) {
    return await updateCart({
        discountCodes: cart.discountCodes.filter((c) => c !== code),
    });
}
export async function addNote(cart, content) {
    return await updateCart({ notes: [...cart.notes, { content }] });
}
export async function editNote(cart, id, content) {
    return await updateCart({
        notes: cart.notes.map((n) => (n._id === id ? { ...n, content } : n)),
    });
}
export async function removeNote(cart, id) {
    return await updateCart({
        notes: cart.notes.filter((n) => n._id !== id),
    });
}
function convertCartItemToInputItem(item) {
    return {
        product: item.product?._id || "",
        quantity: item.quantity,
        customizations: item.customizationLines,
        meta: item.meta,
        reference: item.reference,
    };
}
function convertQuantity(item) {
    return {
        ...item,
        // API returns human-readable decimaled quantities, but wants integers when updating
        quantity: item.quantity * 100,
    };
}
